// Public About page (business-facing).
// Route: /businesses/about: wrapped by PublicLayout.
//
// Content is centralised in /content/about.jsx. Content is bilingual: this
// page resolves the active language via useT() before handing hero/sections
// to MarketingPage.
import MarketingPage from "@/components/MarketingPage";
import CachePublicShell from "@/components/CachePublicShell";
import { useT } from "@/i18n/I18nProvider";
import { ABOUT_BUSINESS } from "@/content/about";

export default function AboutBusiness() {
  const { lang } = useT();
  const content = ABOUT_BUSINESS[lang] || ABOUT_BUSINESS.en;
  return (
    <>
      <CachePublicShell />
      <MarketingPage
        testId="about-business-page"
        audience="business"
        seo={{
          title: "About ConfirmPH for Businesses: Rental management & booking confirmation",
          description:
            "ConfirmPH gives Philippine rental businesses a clearer dashboard for " +
            "bookings, inquiries, vehicles, staff, customer confirmation links, and reviews.",
          canonical: "/businesses/about",
        }}
        hero={content.hero}
        sections={content.sections}
      />
    </>
  );
}
